import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, Spinner, Input, Button } from "reactstrap";
import { Line, Doughnut } from "react-chartjs-2";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../helpers/api_helper";

// Importuri necesare pentru Chart.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Tooltip, Legend);

const Reports = () => {
  document.title = "Rapoarte | PagaSunt Admin";

  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  // Mock data pentru vizualizare (Până faci endpoint-ul)
  useEffect(() => {
    setTimeout(() => {
      setStats({
        revenue: "45.280",
        activeAds: 1240,
        newUsers: 156,
        revenueData: {
          labels: ["Aug", "Sep", "Oct", "Nov", "Dec", "Ian"],
          datasets: [{
            label: "Venituri (RON)",
            data: [12000, 15000, 11000, 19000, 25000, 22000],
            borderColor: "#556ee6",
            backgroundColor: "rgba(85, 110, 230, 0.1)",
            fill: true,
          }]
        },
        categoryData: {
          labels: ["Auto", "Imobiliare", "Electronice", "Servicii"],
          datasets: [{
            data: [400, 300, 340, 200],
            backgroundColor: ["#34c38f", "#556ee6", "#f1b44c", "#f46a6a"],
          }]
        }
      });
      setLoading(false);
    }, 1000);
  }, []);

  if (loading) return <div className="text-center p-5"><Spinner color="primary" /></div>;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Rapoarte & Statistice" />

          {/* KPI CARDS */}
          <Row>
            <Col md={4}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Venit Total</p>
                      <h4 className="mb-0">{stats.revenue} RON</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <i className={"uil uil-money-bill font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Anunțuri Active</p>
                      <h4 className="mb-0">{stats.activeAds}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-success">
                        <i className={"uil uil-layers font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Utilizatori Noi (30 zile)</p>
                      <h4 className="mb-0">+{stats.newUsers}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-info align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-info">
                        <i className={"uil uil-users-alt font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* GRAFIC EVOLUTIE VENITURI */}
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Evoluție Venituri (6 Luni)</CardTitle>
                  <div style={{ height: "300px" }}>
                    <Line data={stats.revenueData} options={{ maintainAspectRatio: false }} />
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* DISTRIBUTIE CATEGORII */}
            <Col lg={4}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Anunțuri per Categorie</CardTitle>
                  <div style={{ height: "300px" }}>
                    <Doughnut data={stats.categoryData} options={{ maintainAspectRatio: false }} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-4">
                    <CardTitle className="flex-grow-1">Generare Raport Personalizat</CardTitle>
                    <div className="d-flex gap-2">
                      <Input type="date" className="form-control-sm" />
                      <Input type="date" className="form-control-sm" />
                      <Button color="primary" size="sm">Export CSV</Button>
                    </div>
                  </div>
                  <p className="text-muted">Alege intervalul dorit pentru a descărca detaliile tranzacțiilor în format tabelar.</p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Reports;